import { createSelector } from '@ngrx/store';
import { outgoingFaxRegisterSelector } from './outgoing-fax-register.reducer';

export const selectFilters = createSelector(outgoingFaxRegisterSelector, (state) => {
   return state.filters;
});
export const selectOrderingOptions = createSelector(outgoingFaxRegisterSelector, (state) => {
   return state.orderingOptions;
});
